import * as React from 'react';
import { BaseButton as Button } from '../../../BaseComponents';
import { useTheme } from '../../../theme';
import { useTranslation } from 'react-i18next';
const AiPredictionFooter = ({ text, onAgree, onDisagree }) => {
    const { AiPredictionFooter: theme } = useTheme('AIPurchasePredictionService');
    const { t } = useTranslation('AIPurchasePredictionService');
    return (React.createElement("div", { className: theme.footer },
        React.createElement(Button, { variant: 'secondary', onClick: onDisagree }, text),
        React.createElement(Button, { variant: 'action', onClick: onAgree }, t('Add and pay'))));
};
export default AiPredictionFooter;
